import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { di } from 'react-magnetic-di';
import { ExperienceName, useAIMateExperienceTracker } from '@atlassian/conversation-assistant-instrumentation';
import { useAssistanceService, useMutation } from '@atlassian/conversation-assistant-service';
export var useAgentFavourites = function useAgentFavourites() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _onError = _ref.onError,
    _onSuccess = _ref.onSuccess,
    _ref$experienceId = _ref.experienceId,
    experienceId = _ref$experienceId === void 0 ? 'ai-mate' : _ref$experienceId,
    product = _ref.product;
  var assistanceService = useAssistanceService({
    experienceId: experienceId,
    product: product
  });
  var experience = useAIMateExperienceTracker();
  var favouriteAgent = useMutation({
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              experience.start({
                id: ExperienceName.FAVOURITE_AGENT,
                name: ExperienceName.FAVOURITE_AGENT
              });
              _context.next = 3;
              return assistanceService.favouriteAgent(id);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function mutationFn(_x) {
        return _mutationFn.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onSuccess: function () {
      var _onSuccess2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              experience.succeed({
                name: ExperienceName.FAVOURITE_AGENT
              });
              _onSuccess === null || _onSuccess === void 0 || _onSuccess({
                favourite: true
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function onSuccess() {
        return _onSuccess2.apply(this, arguments);
      }
      return onSuccess;
    }(),
    onError: function onError(error) {
      experience.fail({
        name: ExperienceName.FAVOURITE_AGENT,
        error: error
      });
      _onError === null || _onError === void 0 || _onError({
        favourite: true
      });
    }
  });
  var unfavouriteAgent = useMutation({
    mutationFn: function () {
      var _mutationFn2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              experience.start({
                id: ExperienceName.UNFAVOURITE_AGENT,
                name: ExperienceName.UNFAVOURITE_AGENT
              });
              _context3.next = 3;
              return assistanceService.unfavouriteAgent(id);
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function mutationFn(_x2) {
        return _mutationFn2.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onSuccess: function () {
      var _onSuccess3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              experience.succeed({
                name: ExperienceName.UNFAVOURITE_AGENT
              });
              _onSuccess === null || _onSuccess === void 0 || _onSuccess({
                favourite: false
              });
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function onSuccess() {
        return _onSuccess3.apply(this, arguments);
      }
      return onSuccess;
    }(),
    onError: function onError(error) {
      experience.fail({
        name: ExperienceName.UNFAVOURITE_AGENT,
        error: error
      });
      _onError === null || _onError === void 0 || _onError({
        favourite: false
      });
    }
  });
  return {
    favouriteAgent: favouriteAgent,
    unfavouriteAgent: unfavouriteAgent
  };
};